import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 650,
    },
    tableHeader: {
        backgroundColor: theme.palette.primary.main,
        '& .MuiTableCell-head': {
            color: theme.palette.primary.contrastText,
        },
        '& th:nth-child(1)': {
            width: 155
        },
        '& th:nth-child(2)': {
            width: 440
        },
    }
}));

const RecentlySentMessagesTable = () => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setLoading(true);
        let url = `/admin/sms/history`;
        fetch(url, {
            method: 'GET',
        })
        .then(response => {
            return response.json();
        })
        .then(result => {
            setData(result);
            setLoading(false);
        })
        .catch(reason => {
            setLoading(false);
            alert('An error prevented getting recently sent text messages.');
        })
    }

    return (
        <TableContainer component={Paper} variant="outlined" square>
            <Table className={classes.table} size="small">
                {!loading && data !== null && (
                    <TableHead className={classes.tableHeader}>
                        <TableRow>
                            <TableCell align="left">Date Sent</TableCell>
                            <TableCell align="left">Message</TableCell>
                            <TableCell align="left"># Recipients</TableCell>
                            <TableCell align="left">Filename</TableCell>
                            <TableCell align="left">User</TableCell>
                        </TableRow>
                    </TableHead>
                )}
                <TableBody>
                {!loading && data !== null && Object.entries(data).map(([i, value]) => (
                    <TableRow key={`row-${i}`}>
                        <TableCell align="left">{value.date_sent_formatted}</TableCell>
                        <TableCell align="left">{value.message}</TableCell>
                        <TableCell align="left">{value.num_recipients}</TableCell>
                        <TableCell align="left">{value.filename}</TableCell>
                        <TableCell align="left">{value.user && value.user.name}</TableCell>
                    </TableRow>
                ))}
                {!loading && data !== null && data.length === 0 && (
                    <TableRow>
                        <TableCell colSpan={14} align="center">No data</TableCell>
                    </TableRow>
                )}
                {loading && (
                    <TableRow>
                        <TableCell colSpan={14} align="center">
                            <CircularProgress color="primary" />
                        </TableCell>
                    </TableRow>
                )}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default RecentlySentMessagesTable;
